// src/config.js ou similaire
const API_BASE_URL = process.env.REACT_APP_ENV === 'production' 
? 'https://fact-10p.averroescode.fr' 
: 'http://localhost:8000';

export default API_BASE_URL;
